import { DISABLE_COMPANY_LIST_CREATE_ON_COLUMN } from "../../../../config/constants";

/**
 * Columns: Company Name, Email, Status, Created Date, Recipe Ingredients,
 * Generic Processes, Actions. As in the legacy grid, the Created column and
 * the two allow-list columns (which replace the old inline links) stay behind
 * `DISABLE_COMPANY_LIST_CREATE_ON_COLUMN`.
 */
/** Hidden below `lg` (tablet/mobile) — the row shows that data as subtext under the name instead, so the table never outgrows a tablet the way the 5-column Product table doesn't. */
const DESKTOP_ONLY = "tw-hidden lg:tw-table-cell";

export const companyTableColumnClass = {
  name: "tw-w-[24%] tw-min-w-[12rem]",
  email: `tw-w-[20%] tw-min-w-[11rem] ${DESKTOP_ONLY}`,
  status: "tw-w-[10%] tw-min-w-[6rem]",
  createdOn: `tw-w-[11%] tw-min-w-[8rem] ${DESKTOP_ONLY}`,
  recipeIngredients: "tw-w-[14%] tw-min-w-[9rem]",
  genericProcesses: "tw-w-[14%] tw-min-w-[9rem]",
  actions: "tw-w-[12%] tw-min-w-[7rem]"
} as const;

export type CompanyColumnKey = Exclude<keyof typeof companyTableColumnClass, "actions">;

export const COMPANY_TABLE_COLUMNS: ReadonlyArray<{ key: CompanyColumnKey; label: string }> = [
  { key: "name", label: "Company Name" },
  { key: "email", label: "Email" },
  { key: "status", label: "Status" },
  ...(!DISABLE_COMPANY_LIST_CREATE_ON_COLUMN
    ? ([
        { key: "createdOn", label: "Created Date" },
        { key: "recipeIngredients", label: "Recipe Ingredients" },
        { key: "genericProcesses", label: "Generic Processes" }
      ] as const)
    : [])
];
